/**
 * application_loaded.ts
 *
 * body末尾で読み込まれ、ページ読み込み完了後の処理を行います。
 *
 * 注意: notify.jsはUMDモジュールのため、side-effect importで
 * グローバルのwindow.jQueryを参照しfactory(jQuery)が評価されます。
 */

// notify.js UMD側のブラウザグローバル分岐でfactory(jQuery)が自動評価される
import '@/javascripts/notify-setup';

// 外部リンクモーダルの初期化
import { initExternalLinkModal } from '@/javascripts/external_link_modal';
import { initCustomLinkMenu } from '@/javascripts/custom_link_menu';
import { initGuidanceModal } from '@/javascripts/guidance_modal';
import { initGuidanceModalPreviewListener } from '@/javascripts/guidance_modal_preview_listener';
import { initAdminMessageNotificationModal } from '@/javascripts/admin_message_notification_modal';

// Share URL Copy
document.addEventListener('DOMContentLoaded', () => {
  const $ = (window as typeof window & { jQuery?: JQueryStatic }).jQuery;
  if (!$) return;

  $('.js-share_copy').on('click', async function () {
    try {
      await navigator.clipboard.writeText(`${location.origin}${location.pathname}`);
      ($ as JQueryStatic & { notify: (msg: string, opts: object) => void }).notify('コピーしました', { position: 'top center', className: 'success' });
    } catch (err) {
      console.error('クリップボードへのコピーに失敗しました:', err);
      ($ as JQueryStatic & { notify: (msg: string, opts: object) => void }).notify('コピーに失敗しました', { position: 'top center', className: 'error' });
    }
  });
});

initExternalLinkModal();
initCustomLinkMenu();
initGuidanceModal();
initGuidanceModalPreviewListener();
initAdminMessageNotificationModal();
